import { commentSchema } from '@/models/commentSchema';
import { apiPath } from '@/redux/apiPath';
import { axiosInstance } from '@/services/api/utils/axiosInstance';
import { ThunkConfig } from '@/types/store';
import { validateDataUsingZodSchema } from '@/utils/validateDataUsingZodSchema';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Comment } from '@/types/models';
import { z } from 'zod';
import { getError } from '@/utils/error-report/getError';

export const getProjectAllComments = createAsyncThunk<Comment[], string, ThunkConfig>(
  'comment/getProjectAllComments',
  async projectId => {
    try {
      const response = await axiosInstance.get<Comment[]>(apiPath.getProjectComments(projectId));

      const isDataValid = validateDataUsingZodSchema(response.data, z.array(commentSchema));

      return isDataValid ? response.data : [];
    } catch (error) {
      return Promise.reject(getError({ error }));
    }
  },
);
